import { isAggregatorFarm, isDuoFarm, isGeelarkFarm, isAdspowerFarm, isMercadoApiFarm } from '../core/farm-kind';
import { renderLaunchSetupBody } from './launch-tab';
import { duoSetupStepsHtml, wireDuoSetup } from './duo-shared';
import { aggregatorSetupStepsHtml } from './aggregator-shared';
import { renderAdspowerSetupBody } from './farm-adspower-setup';
import { renderMercadoSetupBody } from './farm-mercado-setup';
import { t } from '../ui/lang';
/**
 * Unified first "Setup" tab — shown for EVERY farm kind. It's the same tab slot in
 * the strip, but the body is farm-kind specific (initial/first-run setup):
 *   host        → docker launch / VMOS device steps (renderLaunchSetupBody)
 *   duo         → DuoPlus API key + ADB IP whitelist steps (duoSetupStepsHtml)
 *   aggregator  → install the client APK, turn on the screen driver, then provision
 *                 (aggregatorSetupStepsHtml)
 *   adspower    → docker run of the web-reader agent per platform (renderAdspowerSetupBody)
 *   mercado_api → how to get the Mercado Pago API key + CVU (renderMercadoSetupBody)
 *
 * Each body reuses the same helper the matching post-create config modal uses, so the
 * tab and the modal never drift.
 */
export function renderSetupTab(panel, farm) {
    if (isDuoFarm(farm.farm_kind)) {
        panel.innerHTML = `
            <div class="settings-section">
                <h3 class="settings-section__title">${t('farms.duo_setup_title')}</h3>
                <p class="settings-hint">${t('farms.duo_setup_hint')}</p>
                ${duoSetupStepsHtml()}
            </div>
        `;
        wireDuoSetup(panel);
        return;
    }
    if (isAggregatorFarm(farm.farm_kind)) {
        panel.innerHTML = `
            <div class="settings-section">
                <h3 class="settings-section__title">${t('farms.aggregator_setup_title')}</h3>
                <p class="settings-hint">${t('farms.aggregator_setup_hint')}</p>
                ${aggregatorSetupStepsHtml()}
            </div>
        `;
        return;
    }
    if (isGeelarkFarm(farm.farm_kind)) {
        panel.innerHTML = `
            <div class="settings-section">
                <h3 class="settings-section__title">${t('farms.geelark_setup_title')}</h3>
                <p class="settings-hint">${t('farms.geelark_setup_hint')}</p>
            </div>
        `;
        return;
    }
    if (isAdspowerFarm(farm.farm_kind)) {
        // Same shape as the host farm: platform sub-tabs with a plain `docker run` each.
        renderAdspowerSetupBody(panel, farm.name, farm.key ?? '');
        return;
    }
    if (isMercadoApiFarm(farm.farm_kind)) {
        renderMercadoSetupBody(panel);
        return;
    }
    // Host farm: docker launch / VMOS device setup (Standard farm + VMOS sub-tabs).
    renderLaunchSetupBody(panel, farm.name, farm.key ?? '');
}
